import { render } from "./ProjectComponent.vue?vue&type=template&id=b12b471a&scoped=true"
import script from "./ProjectComponent.vue?vue&type=script&lang=js"
export * from "./ProjectComponent.vue?vue&type=script&lang=js"

import "./ProjectComponent.vue?vue&type=style&index=0&id=b12b471a&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b12b471a"]])

export default __exports__